var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.blockType,{ref:"gridItem",tag:"component",staticClass:"grid-block",style:(_vm.blockStyle),attrs:{"block":_vm.block,"highest":_vm.highest}})
}
var staticRenderFns = []

export { render, staticRenderFns }